<template>
    <div class="stage">
        <slot name="header"></slot>
        <slot name="project_templates"></slot>
        <slot name="project_toolbar"></slot>
        <slot name="projects_content"></slot>
    </div>
</template>

<script>
export default {
    name: "StageComp"
}
</script>

<style scoped>
.stage {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 28px 36px 48px;
    overflow-y: scroll;
}
</style>